import moment from "moment";
import { isDigit, tryParseInt, isDate, isNonEmptyString } from "./common";

export const isDatePart = (value?: string, testFn?: Function) => {
  if (!value || !isDigit(value)) {
    return false;
  }

  const _part = tryParseInt(value);

  return testFn?.(_part);
};

export const isMonth = (value?: string) =>
  isDatePart(
    value,
    (_month: number) => !isNaN(_month) && _month > 0 && _month < 13
  );

export const isYear = (value?: string) =>
  isDatePart(value, (_year: number) => !isNaN(_year) && _year > 0);

export const dateToMoment = (
  date?: Date | string | null | undefined
): moment.Moment | undefined => {
  return isDate(date)
    ? moment(date)
    : isNonEmptyString(date)
    ? moment(new Date(date as string))
    : undefined;
};

export const isActive = (
  fromDate?: Date | string | null | undefined,
  toDate?: Date | string | null | undefined
): boolean => {
  // If there's a toDate (dateClosed), the inventory count is CLOSED
  if (toDate) {
    return false;
  }

  const fromM = dateToMoment(fromDate),
    current = moment();

  if (fromM && fromM.isValid()) {
    fromM.hour(0).minute(0).second(0).millisecond(0);
  }

  // If there's a start date, check if current date is after it
  if (fromM && fromM.isValid()) {
    return current.isSameOrAfter(fromM);
  }

  // If no dates are set, consider it OPEN
  return true;
};
